import { Navigate, useLocation } from "react-router-dom";

interface NavigateKeepingQueryProps {
  to: string;
}

/**
 * Редирект-псевдоним, который не теряет строку запроса и якорь.
 *
 * Обычный `<Navigate to="/x" replace />` уводит на голый путь: всё после `?`
 * пропадает. AD-305: реферальная ссылка ведёт на `/register?ref=<код>`, и
 * редирект на `/auth/register` терял код раньше, чем форма успевала его прочитать.
 */
export default function NavigateKeepingQuery({
  to,
}: NavigateKeepingQueryProps) {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: to, search, hash }} replace />;
}
